// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5452) return "static/chunks/5452-a5ed83e9d44dab6c.js";
	if (chunkId === 8229) return "static/chunks/9da6db1e-9a3bb380096c7829.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5528":"ec06105cedfc3081","9774":"994b042ac3cc15f0"}[chunkId] + ".js";
};